import React, { useId, useRef, useEffect } from 'react';
import { cx } from '@arwes/tools';
const IlluminatorSVG = (props) => {
    const { color = 'hsl(0 0% 50% / 5%)', size = 300, className, style } = props;
    const gradientId = useId();
    const circleElementRef = useRef(null);
    useEffect(() => {
        var _a;
        const element = circleElementRef.current;
        const svg = (_a = element.parentElement) === null || _a === void 0 ? void 0 : _a.parentElement; // TODO:
        element.style.transform = `translate(-${size / 2}px, -${size / 2}px)`;
        const onMove = (event) => {
            const bounds = svg.getBoundingClientRect();
            const x = event.clientX - bounds.left + (size / 2);
            const y = event.clientY - bounds.top + (size / 2);
            element.style.opacity = '1';
            element.setAttribute('cx', String(x));
            element.setAttribute('cy', String(y));
        };
        const onHide = () => {
            element.style.opacity = '0';
        };
        document.addEventListener('mousemove', onMove);
        document.addEventListener('mouseleave', onHide);
        return () => {
            document.removeEventListener('mousemove', onMove);
            document.removeEventListener('mouseleave', onHide);
        };
    }, [color, size]);
    return (React.createElement("g", { className: cx('arwes-react-frames-illuminatorsvg', className), style: {
            pointerEvents: 'none',
            ...style
        } },
        React.createElement("defs", null,
            React.createElement("radialGradient", { id: gradientId },
                React.createElement("stop", { offset: '0%', stopColor: color }),
                React.createElement("stop", { offset: '100%', stopColor: 'transparent' }))),
        React.createElement("circle", { ref: circleElementRef, r: size / 2, style: {
                position: 'absolute',
                transition: 'opacity 200ms ease-out',
                opacity: 0
            }, fill: `url(#${gradientId})` })));
};
export { IlluminatorSVG };
